import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=6066f5ae&scoped=true"
import script from "./SubAccount.vue?vue&type=script&lang=js"
export * from "./SubAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066f5ae",
  null
  
)

export default component.exports